import { createTranslationService } from '@services/factories';
import i18n from 'i18next';
import * as React from 'react';

interface Props {
    fallbackName: string;
    documentType: string;
    documentTitle: string;
    renderTitle?: (documentTitle: string) => React.ReactNode;
}

class I9DocumentTitle extends React.Component<Props> {
    static readonly translationContext: string = 'i9SupportingDocuments';
    static defaultProps = {
        renderTitle: (title: string) => title
    }
    // Probably good idea to dependency inject these later
    translationService = createTranslationService();

    componentDidMount() {
        i18n.on('languageChanged', () => this.forceUpdate());
    }

    componentWillUnmount() {
        i18n.off('languageChanged', () => this.forceUpdate());
    }

    render() {
        const {
            documentType,
            fallbackName,
            renderTitle,
            documentTitle
        } = this.props;

        if (!documentType) {
            return renderTitle?.(fallbackName);
        }

        return renderTitle?.(documentTitle);
    }
}

export default I9DocumentTitle;



// WEBPACK FOOTER //
// ./src/components/i9-document-title/index.tsx